<template>
  <div class="component-wrapper">
    <table>
      <tr>
        <th>District</th>
        <th>Number of Active Users</th>
      </tr>
      <tr v-for="(district, index) in districtUsers" :key="index">
        <td>{{ district.districtName }}</td>
        <td>{{ district.districtUsers }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
export default {
  data () {
    return {
      districtUsers: []
    }
  },
  methods: {
    fetchDistrictUsers () {
      fb.usersCollection.orderBy('districtId', 'desc').get().then((snap) => {
        snap.forEach((doc) => {
          if (doc.data().active == true) {
            this.districtUsers.push({
              districtId: doc.data().districtId,
              districtName: doc.data().districtName
            })
          }
        })
      }).then(() => {
        console.log(this.districtUsers)
      })
    }
  },
  mounted () {
    this.fetchDistrictUsers()
  }
}
</script>

<style lang="css" scoped>
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
}
th, td {
  padding: 15px;
  border-bottom: 1px solid #cecece;
}
th {
  background: #0e314d;
  color: white;
  font-weight: 600;
  font-size: 1.2em
}
tr:nth-child(even) {
  background: #f7f7f7;
}
</style>
